import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface Payload { ids: number[]; svg: any }

@Injectable({
  providedIn: "root",
})
export class LorenDownloadPdfService {
  private numOfReports: number;
  private payload: Payload[] = [];

  trigger: Subject<boolean> = new Subject<boolean>();
  payloadReady: Subject<Payload[]> = new Subject<Payload[]>();

  setNumOfReports(num: number) {
    this.numOfReports = num;
  }

  triggerImageSelection() {
    this.trigger.next(true);
  }

  updatePayload(singlePayload: Payload) {
    this.payload.push(singlePayload);
    if (this.payload.length === this.numOfReports) {
      this.payloadReady.next(this.payload);
      this.reset();
    }
  }

  private reset() {
    this.payload = [];
    this.numOfReports = 0;
  }
}
